const pool = new Map();
function getProviderBrick(provider) {
  let brick = pool.get(provider);
  if (brick) {
    return brick;
  }
  brick = document.createElement(provider);
  pool.set(provider, brick);
  return brick;
}
export function unwrapProvider(provider) {
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    const brick = getProviderBrick(provider);
    return brick.resolve(...args);
  };
}
//# sourceMappingURL=unwrapProvider.js.map